import {Component, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {WizardEnums} from '../../wizard.namespace';
import {TerritorialAuthorityProvider} from '../../../../../providers/territorial-authority/territorial-authority.provider';
import {OrganizationContactsService} from '../../services/wizard-form-groups-services/nested-forms/organization-contacts.service';
import {AbstractControl} from '@angular/forms';
import {WizardControlService} from '../../services/wizard-control.service';
import {LaboratoryCommonService} from '../../services/wizard-form-groups-services/nested-forms/laboratory-common.service';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

/**
 * Поля шага визарда 'Общие данные лаборатории'
 */

@Component({
    selector: 'laboratory-common-fields',
    templateUrl: './laboratory-common.component.html'
})
export class LaboratoryCommonFieldsComponent extends AbstractFields implements OnInit {
    public addressTypes = WizardEnums.LaboratoryRealAddressTypes;

    public address: string;

    public canAddDocuments = false;

    constructor(
        public rostehList: TerritorialAuthorityProvider,
        public organizationContacts: OrganizationContactsService,
        private wizardControl: WizardControlService,
        public laboratoryCommonService: LaboratoryCommonService,
        private authService: AuthService,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();

        this.canAddDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentCreate]);

        try {
            this.address = [
                this.organizationContacts.form.get('physical_address_index').value,
                this.organizationContacts.form.get('physical_address_city').value,
                this.organizationContacts.form.get('physical_address').value
            ].filter(v => Boolean(v)).join(', ');
        } catch (e) {
            /**
             *
             */
        }
    }

    goToStep() {
        this.wizardControl.activateStep(WizardEnums.Steps.organizationContacts);
    }

    copyValue(from: AbstractControl, to: AbstractControl) {
        to.patchValue(from.value);
    }
}
